module.exports = __webpack_public_path__ + "static/index-slider-03-fde359252f3216db6ab3c20eae3fc511.jpg";